// extracted by mini-css-extract-plugin
module.exports = {"list":"IncidentDetailsLeft_list__1q5wh"};